<template lang='pug'>
div.container
  h1 Admin
  h3(v-if='isLoading') Loading...
  template(v-else)
    template(v-for='num in numbers')
      .well.admin-number.text-center
        i.fa.fa-2x(:class='num.icon')
        br
        small {{num.name}}
        h3 {{num.nb}}
    template(v-for='chart in charts')
      highcharts(:options="chart.options")
      hr
</template>

<script>
import { Chart } from 'highcharts-vue'
import api from '@/utils/api'

export default {
  data() {
    return {
      allData: undefined
    }
  },
  components: {
    highcharts: Chart
  },
  mounted() {
    if (!this.$store.getters['user/user'].isAdmin) {
      this.$router.replace('/')
      return
    }
    api.get('/stats').then(response => {
      this.allData = response.data
    })
  },
  computed: {
    isLoading() {
      return !this.allData
    },
    numbers () {
      if (this.isLoading) {
        return []
      }
      let nbs = []
      nbs.push({
        name: 'Users',
        icon: 'fa-users',
        nb: this.allData.nbActiveUsersPerMonth[this.allData.nbActiveUsersPerMonth.length - 1].nb
      })
      nbs.push({
        name: 'Ask Users',
        icon: 'fa-users',
        nb: this.allData.nbActiveUsersPerMonth[this.allData.nbActiveUsersPerMonth.length - 1].rawNb
      })
      nbs.push({
        name: 'Groups',
        icon: 'fa-group',
        nb: this.allData.nbGroupsPerMonth[this.allData.nbGroupsPerMonth.length - 1].nb
      })
      nbs.push({
        name: 'Files',
        icon: 'fa-file',
        nb: this.allData.nbFilesPerMonth[this.allData.nbFilesPerMonth.length - 1].nb
      })
      nbs.push({
        name: 'Files size',
        icon: 'fa-file',
        nb: this.allData.sizeOfFilesPerMonth[this.allData.sizeOfFilesPerMonth.length - 1].nb.toFixed(2) + 'Go'
      })
      nbs.push({
        name: 'Events',
        icon: 'fa-calendar',
        nb: this.allData.nbEventsPerMonth[this.allData.nbEventsPerMonth.length - 1].nb
      })
      nbs.push({
        name: 'Messages',
        icon: 'fa-envelope-o',
        nb: this.allData.nbMessagesPerMonth[this.allData.nbMessagesPerMonth.length - 1].nb
      })
      nbs.push({
        name: 'Groups Family',
        icon: 'fa-users',
        nb: this.allData.nbGroupsPerMonth[this.allData.nbGroupsPerMonth.length - 1].nbFamily
      })
      nbs.push({
        name: 'Groups Freetime',
        icon: 'fa-users',
        nb: this.allData.nbGroupsPerMonth[this.allData.nbGroupsPerMonth.length - 1].nbFreetime
      })
      nbs.push({
        name: 'Groups Music',
        icon: 'fa-users',
        nb: this.allData.nbGroupsPerMonth[this.allData.nbGroupsPerMonth.length - 1].nbMusic
      })
      nbs.push({
        name: 'Groups Organisation',
        icon: 'fa-users',
        nb: this.allData.nbGroupsPerMonth[this.allData.nbGroupsPerMonth.length - 1].nbOrganisation
      })
      nbs.push({
        name: 'Groups Sport',
        icon: 'fa-users',
        nb: this.allData.nbGroupsPerMonth[this.allData.nbGroupsPerMonth.length - 1].nbSport
      })
      nbs.push({
        name: 'Groups Work',
        icon: 'fa-users',
        nb: this.allData.nbGroupsPerMonth[this.allData.nbGroupsPerMonth.length - 1].nbWork
      })
      return nbs
    },
    charts() {
      if (this.isLoading) {
        return []
      }
      return [
        {
          options: this.getChartOptions(
            this.allData.nbActiveUsersPerMonth,
            'Users',
            {
              rawNb: 'All users (with duplicate)'
            }
          )
        },
        {
          options: this.getChartOptions(
            this.allData.nbGroupsPerMonth,
            'Groups',
            {
              nbMusic: 'Music groops',
              nbWork: 'Work groops',
              nbFamily: 'Family groops',
              nbSport: 'Sport groops',
              nbFreetime: 'Freetime groops',
              nbOrganisation: 'Organisation groops'
            }
          )
        },
        {
          options: this.getChartOptions(this.allData.nbTokensPerMonth, 'Tokens')
        },
        {
          options: this.getChartOptions(this.allData.nbEventsPerMonth, 'Events')
        },
        {
          options: this.getChartOptions(
            this.allData.nbMessagesPerMonth,
            'Messages'
          )
        },
        {
          options: this.getChartOptions(
            this.allData.sizeOfFilesPerMonth,
            'Files size'
          )
        }
      ]
    }
  },
  methods: {
    getChartOptions(data, title, otherCurves = {}) {
      const chartData = {
        title: {
          text: title
        },
        chart: {
          zoomType: 'xy'
        },
        xAxis: {
          categories: []
        },
        series: [
          {
            name: title,
            fillColor: 'rgba(151,187,205,0.2)',
            strokeColor: 'rgba(151,187,205,1)',
            pointColor: 'rgba(151,187,205,1)',
            pointStrokeColor: '#fff',
            pointHighlightFill: '#fff',
            pointHighlightStroke: 'rgba(151,187,205,1)',
            data: [],
            visible: false
          },
          {
            name: title + ' (non cumulé)',
            fillColor: 'rgba(220,220,220,0.2)',
            strokeColor: 'rgba(220,220,220,1)',
            pointColor: 'rgba(220,220,220,1)',
            pointStrokeColor: '#fff',
            pointHighlightFill: '#fff',
            pointHighlightStroke: 'rgba(220,220,220,1)',
            data: []
          }
        ],
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: function() {
                  this.series.hide()
                }
              }
            }
          }
        }
      }
      for (let curve in otherCurves) {
        chartData.series.push({
          name: otherCurves[curve],
          fillColor: 'rgba(220,220,220,0.2)',
          strokeColor: 'rgba(220,220,220,1)',
          pointColor: 'rgba(220,220,220,1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(220,220,220,1)',
          data: [],
          visible: false
        })
      }
      let last = data[0].nb
      let i = 0
      while (i < data.length) {
        chartData.xAxis.categories.push(data[i].month)
        chartData.series[0].data.push(data[i].nb)
        chartData.series[1].data.push(data[i].nb - last)
        let j = 2
        for (let curve in otherCurves) {
          chartData.series[j].data.push(data[i][curve])
          j++
        }
        last = data[i].nb
        i++
      }
      return chartData
    }
  }
}
</script>

<style>
.admin-number {
  display: inline-block;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// Administration.vue?670d61df